import Table from 'src/components/atoms/table/table';

export const TimesheetsTableHeaderUser = () => {
  return (
    <Table.Row>
      <Table.HeaderCell>Dipendente</Table.HeaderCell>
      <Table.HeaderCell>Mansione</Table.HeaderCell>
      <Table.HeaderCell></Table.HeaderCell>
    </Table.Row>
  );
};
